import { Avatar, CircularProgress, Input } from "@mui/joy";
import { BASE_URL, BLACK, PRIMARY, STATUS, WHITE } from "../../appConstants";
import AppLogo from "./AppLogo";
import React, {
  Dispatch,
  MutableRefObject,
  RefObject,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import SupportModal from "./SupportModal";
import { Button, Select, Option, selectClasses } from "@mui/joy";
import { UUID } from "crypto";
import axios from "axios";
import appError from "../../appError";
import { useDispatch, useSelector } from "react-redux";
import { updateBrandData } from "../../redux/appDataSlice";
import { useLocation, useNavigate } from "react-router-dom";
import Navigation from "./Navigation";
import { idText } from "typescript";
import { drop } from "lodash";
import toast from "react-hot-toast";
import { stat } from "fs";

type HeaderProps = {
  clickedOnMenu: (menu: string) => void;
};
type BrandObject = {
  brand_id: string;
  brand_name: string;
  stage: string;
  onboarding_type: string;
};
type DashboardObject = {
  brand_power_bi_dashboard_id: UUID;
  dashboard_type: string;
  url: string;
};

const Header: React.FC<HeaderProps> = ({ clickedOnMenu }) => {
  const { pathname } = useLocation();
  let menuRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const menuButtonRef = useRef<HTMLDivElement | null>(null); // Menu button reference
  const [dashboards, setDashboards] = useState<DashboardObject[]>([]);
  const {
    stage,
    brand_id,
    platform_id,
    onboarding_type,
    brand_power_bi_dashboard_id,
    brand_power_bi_dashboard_type_id,
  } = useSelector((state: any) => state.appData);
  const location = useLocation();

  const brand_array: BrandObject[] = useSelector(
    (state: any) => state.appData.brand_array
  );
  const user_type = localStorage.getItem("user_type");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brandId = useSelector((state: any) => state.appData.brand_id);
  const [open, setOpen] = useState<boolean>(false); // for old header dropdown
  const [newopen, setNewopen] = useState<boolean>(false); // for new header dropdown
  const [openBrandDropdown, setOpenBrandDropdown] = useState<Boolean>(false);
  const [openPlatformDropdown, setOpenPlatformDropdown] =
    useState<Boolean>(false);
  const [openDashboardDropdown, setOpenDashboardDropdown] =
    useState<Boolean>(false);
  const [openSupport, setOpenSupport] = useState<boolean>(true);
  const [showMenuEl, setShowMenuEl] = useState<boolean>(false);
  const [showAvatarEl, setShowAvatarEl] = useState<boolean>(false);
  //const [brand_array, setBrandArray] = useState<BrandObject[]>([]);
  const [refreshDataToggle, setRefreshDataToggle] = useState<boolean>(false);
  const [loadingRefresh, setLoadingRefresh] = useState<boolean>(false);

  const closealldropdowns = () => {
    setOpenDashboardDropdown(false);
    setOpenPlatformDropdown(false);
    setOpenBrandDropdown(false);
  }

  const menuItems = useMemo(
    () => [
      { name: "Category", id: "category" },
      { name: "Product", id: "product" },
      { name: "Company Details", id: "companyDetails" },
      { name: "Campaigns", id: "campaigns" },
      { name: "Product Mapping", id: "productMapping" },
      { name: "Favorite Selection", id: "favoriteSelection" },
      { name: "Reports", id: "reports" },
    ],
    []
  );
  type subDashboard = {
    sub_module_for_dashboard_type: string;
    sub_module_for_dashboard_type_id: string;
    url: string;
  };
  const [subDashboards, setSubDashboards] = useState<subDashboard[]>([]);

  const fetchSubDashboards = async () => {
    try {
      if (!(brand_id && platform_id && brand_power_bi_dashboard_type_id)) {
        return;
      }
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${BASE_URL}user/getAuthUserSubDashboardByBrandIdPlatformIdAndDashboardId?brand_id=${brand_id}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.data?.data?.sub_dashboards) {
        setSubDashboards([...res?.data?.data?.sub_dashboards]);
        // setSubDashboards([...res?.data?.data?.sub_dashboards, {
        //   url: "/unmappedData/productMaster",
        //   sub_module_for_dashboard_type_id: "",
        //   sub_module_for_dashboard_type: "Unmapped Data"
        // }]);
      }
    } catch (error) {
      appError(error);
    }
  };

  useEffect(() => {
    fetchSubDashboards();
  }, [brand_id, platform_id, brand_power_bi_dashboard_type_id]);
  // useEffect(() => {
  //     fetchBrands();
  // }, []);

  // useEffect(() => {
  //     if (stage === "ONBOARDING") {
  //         // if (onboarding_type === "MANUAL") {
  //         //     navigate("/onBoardingManual");
  //         // } else {
  //         //     navigate("/onBoarding");
  //         // }
  //         navigate("/onBoarding");
  //     } else if (stage === "CRAWLING") {
  //         navigate("/onBoarding/crawl");
  //     } else if (stage === "CRAWLED") {
  //         navigate("/onBoarding/categoryMapping");
  //     }

  //     else if (stage === "ONBOARDED") {
  //         fetchDashboards();
  //         //navigate("/dashboard");
  //     } else if (stage === "PREPARING_DASHBOARD") {
  //         navigate("/preparingDashboard");
  //     } else if (stage === "loading") {
  //         setDashboards([]);
  //         dispatch(updateBrandData({ brand_power_bi_dashboard_id: "loading", power_bi_url: "loading" }));
  //     } else {
  //         setDashboards([]);
  //         dispatch(updateBrandData({ brand_power_bi_dashboard_id: "nodashboard", power_bi_url: "nodashboard" }));
  //     }
  // }, [brandId, stage]);

  // const fetchDashboards = async () => {
  //     try {
  //         setLodingDashboards(true);
  //         const token = localStorage.getItem("token");
  //         if (!brandId) {
  //             return;
  //         }
  //         const brandsRes = await axios.get(`${BASE_URL}brand/powerBi?brand_id=${brandId}`, {
  //             headers: {
  //                 "Authorization": `Bearer ${token}`
  //             }
  //         });
  //         const dashboards: DashboardObject[] = brandsRes?.data?.data?.dashboard_array;
  //         if (dashboards.length) {
  //             const { brand_power_bi_dashboard_id, url } = dashboards[0];
  //             dispatch(updateBrandData({ brand_power_bi_dashboard_id, power_bi_url: url }));
  //             setDashboards(dashboards)
  //         } else {
  //             dispatch(updateBrandData({ brand_power_bi_dashboard_id: "nodashboard", power_bi_url: "nodashboard" }));
  //             setDashboards([])
  //         }

  //     } catch (error) {
  //         appError(error);
  //     } finally {
  //         setLodingDashboards(false);
  //     }
  // }

  // const fetchBrands = async () => {
  //     try {
  //         setLoadingBrands(true);
  //         const token = localStorage.getItem("token");
  //         const brandsRes = await axios.get(`${BASE_URL}brand/getMyBrands`, {
  //             headers: {
  //                 "Authorization": `Bearer ${token}`
  //             }
  //         });
  //         const brands: BrandObject[] = brandsRes?.data?.data?.brands;
  //         if (brands.length) {
  //             // setBrandArray(brands);
  //             const { brand_id, stage, onboarding_type } = brands[0];
  //             dispatch(updateBrandData({ brand_id, stage, onboarding_type, brand_array: brands }));
  //         }
  //     } catch (error) {
  //         appError(error);
  //     } finally {
  //         setLoadingBrands(false);
  //     }
  // }

  const onClickElementHandler = (url: string) => {
    setNewopen(false);
    setShowAvatarEl(false);
    setShowMenuEl(false);
    clickedOnMenu(url);
  };

  const onAvatarClickHandler = () => {
    setOpenBrandDropdown(false);
    setOpenPlatformDropdown(false);
    setOpenDashboardDropdown(false);
    setNewopen(function (prevState) {
      if (prevState && showMenuEl) {
        setShowAvatarEl(true);
        setShowMenuEl(false);
        return true;
      } else if (prevState && showAvatarEl) {
        setShowAvatarEl(false);
        return false;
      } else {
        setShowAvatarEl(true);
        return true;
      }
    });
  };

  // const onMenuClickHandler = () => {
  //   setOpen(function (prevState) {
  //     if (prevState && showAvatarEl) {
  //       setShowAvatarEl(false);
  //       setShowMenuEl(true);
  //       return true;
  //     } else if (prevState && showMenuEl) {
  //       setShowMenuEl(false);
  //       return false;
  //     } else {
  //       setShowMenuEl(true);
  //       return true;
  //     }
  //   });
  // };

  // useEffect(() => {
  //   menuRef.current?.addEventListener("mouseleave", () => {
  //     setNewopen(false);
  //     setShowAvatarEl(false);
  //     setShowMenuEl(false);
  //   });

  //   return () => {
  //     menuRef.current?.removeEventListener("mouseleave", () => {});
  //   };
  // }, [newopen]);

  const onSelectBrandHandler = (event: any, value: any) => {
    const brand: BrandObject | undefined = brand_array.find(
      (brand) => brand.brand_id === value
    );
    if (brand) {
      const { brand_id, stage, onboarding_type } = brand;
      dispatch(updateBrandData({ brand_id, stage, onboarding_type }));
    }
  };
  const onSelectDashboardHandler = (event: any, value: any) => {
    const brand: DashboardObject | undefined = dashboards.find(
      (brand) => brand.brand_power_bi_dashboard_id === value
    );

    if (brand) {
      const { url, brand_power_bi_dashboard_id } = brand;
      dispatch(
        updateBrandData({ power_bi_url: url, brand_power_bi_dashboard_id })
      );
    }
  };

  const onLogoutClickHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_type");
    localStorage.removeItem("full_name");
    localStorage.removeItem("brand");
    localStorage.removeItem("platform");
    localStorage.removeItem("dashboard");
    localStorage.removeItem("sub-dashboard");
    localStorage.removeItem("BrandRange");
    dispatch(
      updateBrandData({
        brand_id: "",
        stage: "loading",
        onboarding_type: null,
        power_bi_url: "loading",
        brand_power_bi_dashboard_id: "",
        platform_id: "",
        brand_array: [],
        category_hierarchy_level: null,
      })
    );
    navigate("/login");
  };

  const full_name = localStorage.getItem("full_name");
  const words: string[] = full_name ? full_name.split(" ") : [" "];

  const handleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node) &&
      menuButtonRef.current &&
      !menuButtonRef.current.contains(event.target as Node)
    ) {
      setNewopen(false); // Close the dropdown if clicked outside
    }
  };

  // Add event listener to detect clicks outside
  useEffect(() => {
    // Attach the click event listener to the document
    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const onRefreshHandler = async () => {
    setLoadingRefresh(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${BASE_URL}brand/refresh/${platform_id}/${brand_power_bi_dashboard_type_id}?brand_id=${brand_id}`, {

        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const {status, message} = res?.data;

      if(status === "fail"){
        appError(message);
      } else if(status === "success"){
        toast.success("Powerbi Dashboard refresh has been proceed");
      }

      // toast.success("Data refreshed successfully");
    } catch (error: any) {
      let message =  error?.response?.data?.message || error || "Something went wrong";

      appError(message);
    } finally {
      setLoadingRefresh(false);
    }

  }

  return (
    <div
      style={{ backgroundColor: "#1C1C1C", height: 72 }}
      className="flex flex-row items-center justify-between px-11"
    >
      <div
        onClick={() => clickedOnMenu("/dashboard")}
        style={{ cursor: "pointer" }}
      >
        <AppLogo height={32} />
      </div>

      <div className="flex flex-row items-center">
        {
          loadingRefresh ? (
            <CircularProgress
              size="sm"
              sx={{ marginRight: "24px", color: WHITE }}
            />
          ) : (
            <>

              {refreshDataToggle && location.pathname.includes("/dashboard")  && (
                <div
                onClick={onRefreshHandler}
                className="mr-4 cursor-pointer" style={{ color: "white" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
                  <path d="M14.1667 0.999771L14.7646 2.11754C15.1689 2.87324 15.371 3.25108 15.2374 3.4129C15.1037 3.57472 14.6635 3.44403 13.7831 3.18265C12.9029 2.92133 11.9684 2.78072 11 2.78072C5.75329 2.78072 1.5 6.90823 1.5 11.9998C1.5 13.679 1.96262 15.2533 2.77093 16.6093M7.83333 22.9998L7.23536 21.882C6.83108 21.1263 6.62894 20.7485 6.7626 20.5866C6.89627 20.4248 7.33649 20.5555 8.21689 20.8169C9.09709 21.0782 10.0316 21.2188 11 21.2188C16.2467 21.2188 20.5 17.0913 20.5 11.9998C20.5 10.3206 20.0374 8.74625 19.2291 7.39025" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            )}
            </>
          )

        }



        <Navigation
          openBrandDropdown={openBrandDropdown}
          setOpenBrandDropdown={setOpenBrandDropdown}
          openPlatformDropdown={openPlatformDropdown}
          setOpenPlatformDropdown={setOpenPlatformDropdown}
          openDashboardDropdown={openDashboardDropdown}
          setOpenDashboardDropdown={setOpenDashboardDropdown}
          setNewopen={setNewopen}
          clickedOnMenu={clickedOnMenu}
          closealldropdowns={closealldropdowns}
          refreshDataToggle={refreshDataToggle}
          setRefreshDataToggle={setRefreshDataToggle}
        />
        {/* {
                    stage === "ONBOARDED" && pathname === "/dashboard" && dashboards.length > 0 && (
                        <>
                            {
                                loadingDashboards ? <CircularProgress size="sm" sx={{ marginX: "24px" }} /> : (
                                    <div className="mr-2" >
                                        <Select
                                            value={brand_power_bi_dashboard_id}
                                            onChange={onSelectDashboardHandler}
                                            placeholder="Select Dashboards"
                                            indicator={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="Iconography">
                                                    <path id="Vector" d="M13.354 6.35354L8.35403 11.3535C8.30759 11.4 8.25245 11.4369 8.19175 11.4621C8.13105 11.4872 8.06599 11.5002 8.00028 11.5002C7.93457 11.5002 7.86951 11.4872 7.80881 11.4621C7.74811 11.4369 7.69296 11.4 7.64653 11.3535L2.64653 6.35354C2.55271 6.25972 2.5 6.13247 2.5 5.99979C2.5 5.86711 2.55271 5.73986 2.64653 5.64604C2.74035 5.55222 2.8676 5.49951 3.00028 5.49951C3.13296 5.49951 3.26021 5.55222 3.35403 5.64604L8.00028 10.2929L12.6465 5.64604C12.693 5.59958 12.7481 5.56273 12.8088 5.53759C12.8695 5.51245 12.9346 5.49951 13.0003 5.49951C13.066 5.49951 13.131 5.51245 13.1917 5.53759C13.2524 5.56273 13.3076 5.59958 13.354 5.64604C13.4005 5.69249 13.4373 5.74764 13.4625 5.80834C13.4876 5.86904 13.5006 5.93409 13.5006 5.99979C13.5006 6.06549 13.4876 6.13054 13.4625 6.19124C13.4373 6.25193 13.4005 6.30708 13.354 6.35354Z" fill="#1886FE" />
                                                </g>
                                            </svg>}

                                            sx={{
                                                height: "28px",
                                                marginLeft: "16px",
                                                minWidth: 160,
                                                color: "#1886FE", borderRadius: 8, borderColor: "#1886FE",
                                                [`& .${selectClasses.indicator}`]: {
                                                    transition: '0.2s',
                                                    [`&.${selectClasses.expanded}`]: {
                                                        transform: 'rotate(-180deg)',
                                                    },
                                                },
                                            }}
                                        >
                                            {
                                                dashboards?.map(el => {
                                                    return <Option value={el?.brand_power_bi_dashboard_id}  >{el?.dashboard_type}</Option>
                                                })
                                            }
                                        </Select>
                                    </div>
                                )
                            }



                        </>

                    )
                }
                {
                    loadingBrands ? <CircularProgress size="sm" sx={{ marginX: "24px" }} /> : (
                        <div className="mr-6" >
                            <Select
                                value={brandId}
                                onChange={onSelectBrandHandler}
                                placeholder="Select Brand"
                                indicator={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Iconography">
                                        <path id="Vector" d="M13.354 6.35354L8.35403 11.3535C8.30759 11.4 8.25245 11.4369 8.19175 11.4621C8.13105 11.4872 8.06599 11.5002 8.00028 11.5002C7.93457 11.5002 7.86951 11.4872 7.80881 11.4621C7.74811 11.4369 7.69296 11.4 7.64653 11.3535L2.64653 6.35354C2.55271 6.25972 2.5 6.13247 2.5 5.99979C2.5 5.86711 2.55271 5.73986 2.64653 5.64604C2.74035 5.55222 2.8676 5.49951 3.00028 5.49951C3.13296 5.49951 3.26021 5.55222 3.35403 5.64604L8.00028 10.2929L12.6465 5.64604C12.693 5.59958 12.7481 5.56273 12.8088 5.53759C12.8695 5.51245 12.9346 5.49951 13.0003 5.49951C13.066 5.49951 13.131 5.51245 13.1917 5.53759C13.2524 5.56273 13.3076 5.59958 13.354 5.64604C13.4005 5.69249 13.4373 5.74764 13.4625 5.80834C13.4876 5.86904 13.5006 5.93409 13.5006 5.99979C13.5006 6.06549 13.4876 6.13054 13.4625 6.19124C13.4373 6.25193 13.4005 6.30708 13.354 6.35354Z" fill="#1886FE" />
                                    </g>
                                </svg>}

                                sx={{
                                    height: "28px",
                                    marginLeft: "16px",
                                    minWidth: 160,
                                    color: "#1886FE", borderRadius: 8, borderColor: "#1886FE",
                                    [`& .${selectClasses.indicator}`]: {
                                        transition: '0.2s',
                                        [`&.${selectClasses.expanded}`]: {
                                            transform: 'rotate(-180deg)',
                                        },
                                    },
                                }}
                            >
                                {
                                    brand_array?.map(el => {
                                        return <Option value={el?.brand_id}  >{el?.brand_name}</Option>
                                    })
                                }
                            </Select>
                        </div>
                    )
                } */}

        {/* <div style={{ color: WHITE.W_100, border: `1px solid ${WHITE.W_100}`, borderRadius: 8 }} className="flex flex-row items-center py-1 p-2" >
                    <svg className="mr-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M15.7727 4.27031C15.025 3.51514 14.1357 2.91486 13.1558 2.50383C12.1758 2.09281 11.1244 1.87912 10.0617 1.875H10C7.84512 1.875 5.77849 2.73102 4.25476 4.25476C2.73102 5.77849 1.875 7.84512 1.875 10V14.375C1.875 14.8723 2.07254 15.3492 2.42417 15.7008C2.77581 16.0525 3.25272 16.25 3.75 16.25H5C5.49728 16.25 5.97419 16.0525 6.32583 15.7008C6.67746 15.3492 6.875 14.8723 6.875 14.375V11.25C6.875 10.7527 6.67746 10.2758 6.32583 9.92417C5.97419 9.57254 5.49728 9.375 5 9.375H3.15313C3.27366 8.07182 3.76315 6.83 4.56424 5.79508C5.36532 4.76016 6.44481 3.97502 7.67617 3.53169C8.90753 3.08836 10.2398 3.0052 11.5167 3.29196C12.7936 3.57872 13.9624 4.22352 14.8859 5.15078C16.0148 6.28539 16.7091 7.78052 16.8477 9.375H15C14.5027 9.375 14.0258 9.57254 13.6742 9.92417C13.3225 10.2758 13.125 10.7527 13.125 11.25V14.375C13.125 14.8723 13.3225 15.3492 13.6742 15.7008C14.0258 16.0525 14.5027 16.25 15 16.25H16.875C16.875 16.7473 16.6775 17.2242 16.3258 17.5758C15.9742 17.9275 15.4973 18.125 15 18.125H10.625C10.4592 18.125 10.3003 18.1908 10.1831 18.3081C10.0658 18.4253 10 18.5842 10 18.75C10 18.9158 10.0658 19.0747 10.1831 19.1919C10.3003 19.3092 10.4592 19.375 10.625 19.375H15C15.8288 19.375 16.6237 19.0458 17.2097 18.4597C17.7958 17.8737 18.125 17.0788 18.125 16.25V10C18.1291 8.93717 17.9234 7.88398 17.5197 6.90077C17.1161 5.91757 16.5224 5.02368 15.7727 4.27031ZM5 10.625C5.16576 10.625 5.32473 10.6908 5.44194 10.8081C5.55915 10.9253 5.625 11.0842 5.625 11.25V14.375C5.625 14.5408 5.55915 14.6997 5.44194 14.8169C5.32473 14.9342 5.16576 15 5 15H3.75C3.58424 15 3.42527 14.9342 3.30806 14.8169C3.19085 14.6997 3.125 14.5408 3.125 14.375V10.625H5ZM15 15C14.8342 15 14.6753 14.9342 14.5581 14.8169C14.4408 14.6997 14.375 14.5408 14.375 14.375V11.25C14.375 11.0842 14.4408 10.9253 14.5581 10.8081C14.6753 10.6908 14.8342 10.625 15 10.625H16.875V15H15Z" fill="white" />
                    </svg>
                    Support
                </div> */}
        <div
          ref={menuButtonRef}
          onClick={onAvatarClickHandler}
          className="ml-4 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        {/* <div onClick={onMenuClickHandler} className="cursor-pointer" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>  */}
      </div>
      {/* Menu */}
      {newopen && (
        <div
          ref={menuRef}
          className="flex w-[200px] py-[8px] flex-col items-center gap-[8px] rounded-[8px]"
          style={{
            position: "absolute",
            top: 50,
            right: 40,
            backgroundColor: WHITE.W_100,
            zIndex: 999,
            boxShadow: `0px 4px 10px 4px rgba(130,130,130,0.10)`,
          }}
        >
          {/* div for Hi Name */}
          <div className="flex h-[34px] py-[8px] px-[16px] items-center gap-[10px] self-stretch">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM6.945 18.5156C7.48757 17.6671 8.23501 16.9688 9.11843 16.4851C10.0019 16.0013 10.9928 15.7478 12 15.7478C13.0072 15.7478 13.9982 16.0013 14.8816 16.4851C15.765 16.9688 16.5124 17.6671 17.055 18.5156C15.6097 19.6397 13.831 20.2499 12 20.2499C10.169 20.2499 8.39032 19.6397 6.945 18.5156ZM9 11.25C9 10.6567 9.17595 10.0766 9.5056 9.58329C9.83524 9.08994 10.3038 8.70542 10.852 8.47836C11.4001 8.2513 12.0033 8.19189 12.5853 8.30764C13.1672 8.4234 13.7018 8.70912 14.1213 9.12868C14.5409 9.54824 14.8266 10.0828 14.9424 10.6647C15.0581 11.2467 14.9987 11.8499 14.7716 12.3981C14.5446 12.9462 14.1601 13.4148 13.6667 13.7444C13.1734 14.0741 12.5933 14.25 12 14.25C11.2044 14.25 10.4413 13.9339 9.87868 13.3713C9.31607 12.8087 9 12.0456 9 11.25ZM18.165 17.4759C17.3285 16.2638 16.1524 15.3261 14.7844 14.7806C15.5192 14.2019 16.0554 13.4085 16.3184 12.5108C16.5815 11.6132 16.5582 10.6559 16.252 9.77207C15.9457 8.88825 15.3716 8.12183 14.6096 7.5794C13.8475 7.03696 12.9354 6.74548 12 6.74548C11.0646 6.74548 10.1525 7.03696 9.39044 7.5794C8.62839 8.12183 8.05432 8.88825 7.74805 9.77207C7.44179 10.6559 7.41855 11.6132 7.68157 12.5108C7.94459 13.4085 8.4808 14.2019 9.21563 14.7806C7.84765 15.3261 6.67147 16.2638 5.835 17.4759C4.77804 16.2873 4.0872 14.8185 3.84567 13.2464C3.60415 11.6743 3.82224 10.0658 4.47368 8.61478C5.12512 7.16372 6.18213 5.93192 7.51745 5.06769C8.85276 4.20346 10.4094 3.74367 12 3.74367C13.5906 3.74367 15.1473 4.20346 16.4826 5.06769C17.8179 5.93192 18.8749 7.16372 19.5263 8.61478C20.1778 10.0658 20.3959 11.6743 20.1543 13.2464C19.9128 14.8185 19.222 16.2873 18.165 17.4759Z"
                fill="#1C1C1C"
              />
            </svg>
            <div
              style={{
                fontSize: "18px",
                fontWeight: 500,
                lineHeight: "24px",
                color: BLACK.B_100,
              }}
            >
              Hi {full_name ? `${words[0]}!` : ""}
            </div>
          </div>
          {/* for Line */}
          <div
            className=" w-[85%]"
            style={{ border: "1px solid rgba(28,28,28,0.05)" }}
          ></div>
          {/* for sub dashboards */}

          {subDashboards.length > 0 && (
            <div className="flex flex-col items-start self-stretch">
              {subDashboards.map((sub_dashboard, i) => {
                return (
                  <div
                    onClick={() => onClickElementHandler(sub_dashboard.url)}
                    className="flex h-[34px] py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
                    key={sub_dashboard.sub_module_for_dashboard_type_id}
                  >
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: "18px",
                        color: BLACK.B_80,
                      }}
                    >
                      {sub_dashboard.sub_module_for_dashboard_type}
                    </div>
                  </div>
                );
              })}

            </div>
          )}
          {/* {mastersAccessForPlatforms?.includes(platform_id) && (<div
            onClick={() => onClickElementHandler(`masters/${brand_id}/${platform_id}`)}
            className="flex h-[34px] py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
          //key={sub_dashboard.sub_module_for_dashboard_type_id}
          >
            <div
              style={{
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "18px",
                color: BLACK.B_80,
              }}
            >
              Masters
            </div>
          </div>)} */}
          {/* for Line */}
          {subDashboards.length !== 0 && (
            <div
              className="w-[85%]"
              style={{ border: "1px solid rgba(28,28,28,0.05)" }}
            ></div>
          )}
          {/* for All Dashboards */}
          <div className="flex flex-col items-start gap-[10px] self-stretch">
            {user_type === "ADMIN" && (
              <div
                className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
                onClick={() =>
                  onClickElementHandler(
                    "/platformDashboardManagement/platformList"
                  )
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M5.74984 10.7916H11.2498C11.4036 10.7916 11.5323 10.7402 11.6359 10.6373C11.7396 10.5345 11.7915 10.4068 11.7915 10.2543C11.7915 10.1018 11.7396 9.97274 11.6359 9.86704C11.5323 9.76121 11.4036 9.70829 11.2498 9.70829H5.74984C5.59609 9.70829 5.46741 9.75975 5.3638 9.86267C5.26005 9.96545 5.20817 10.0931 5.20817 10.2456C5.20817 10.3981 5.26005 10.5272 5.3638 10.6329C5.46741 10.7387 5.59609 10.7916 5.74984 10.7916ZM5.74984 8.29163H11.2498C11.4036 8.29163 11.5323 8.24017 11.6359 8.13725C11.7396 8.03447 11.7915 7.90683 11.7915 7.75433C11.7915 7.60183 11.7396 7.47274 11.6359 7.36704C11.5323 7.26121 11.4036 7.20829 11.2498 7.20829H5.74984C5.59609 7.20829 5.46741 7.25975 5.3638 7.36267C5.26005 7.46545 5.20817 7.59308 5.20817 7.74558C5.20817 7.89808 5.26005 8.02718 5.3638 8.13288C5.46741 8.23871 5.59609 8.29163 5.74984 8.29163ZM3.7563 15.5833C3.38116 15.5833 3.06407 15.4537 2.80505 15.1945C2.54602 14.9354 2.4165 14.6181 2.4165 14.2427V5.75058C2.4165 5.37517 2.54602 5.05899 2.80505 4.80204C3.06407 4.5451 3.38116 4.41663 3.7563 4.41663H16.2434C16.6185 4.41663 16.9356 4.54621 17.1946 4.80538C17.4537 5.06454 17.5832 5.38183 17.5832 5.75725V14.2493C17.5832 14.6248 17.4537 14.9409 17.1946 15.1979C16.9356 15.4548 16.6185 15.5833 16.2434 15.5833H3.7563ZM3.7563 14.5H16.2434C16.3075 14.5 16.3663 14.4732 16.4196 14.4198C16.4731 14.3664 16.4998 14.3077 16.4998 14.2435V5.75642C16.4998 5.69225 16.4731 5.6335 16.4196 5.58017C16.3663 5.52669 16.3075 5.49996 16.2434 5.49996H3.7563C3.69213 5.49996 3.63338 5.52669 3.58005 5.58017C3.52657 5.6335 3.49984 5.69225 3.49984 5.75642V14.2435C3.49984 14.3077 3.52657 14.3664 3.58005 14.4198C3.63338 14.4732 3.69213 14.5 3.7563 14.5Z"
                    fill="#1C1C1C"
                    fill-opacity="0.8"
                  />
                </svg>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    color: BLACK.B_80,
                  }}
                >
                  Platform & Dashboard
                </div>
              </div>
            )}
            {user_type === "ADMIN" && (
              <div
                className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
                onClick={() =>
                  onClickElementHandler("/brandManagement/brandList")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.50088 5.96476C6.28116 5.96476 6.09414 6.04164 5.93984 6.19539C5.78539 6.34914 5.70817 6.5358 5.70817 6.75539C5.70817 6.97511 5.78505 7.16212 5.9388 7.31643C6.09255 7.47087 6.27921 7.5481 6.4988 7.5481C6.71852 7.5481 6.90553 7.47122 7.05984 7.31747C7.21428 7.16372 7.2915 6.97698 7.2915 6.75726C7.2915 6.53768 7.21463 6.35066 7.06088 6.19622C6.90713 6.04191 6.72046 5.96476 6.50088 5.96476ZM6.50088 13.4518C6.28116 13.4518 6.09414 13.5287 5.93984 13.6825C5.78539 13.8362 5.70817 14.023 5.70817 14.2427C5.70817 14.4623 5.78505 14.6493 5.9388 14.8037C6.09255 14.958 6.27921 15.0352 6.4988 15.0352C6.71852 15.0352 6.90553 14.9583 7.05984 14.8046C7.21428 14.6508 7.2915 14.4641 7.2915 14.2446C7.2915 14.0248 7.21463 13.8378 7.06088 13.6835C6.90713 13.5291 6.72046 13.4518 6.50088 13.4518ZM4.32046 3.6731H15.6792C15.9353 3.6731 16.15 3.75955 16.3234 3.93247C16.4966 4.10525 16.5832 4.31941 16.5832 4.57497V8.88768C16.5832 9.16046 16.4966 9.38733 16.3234 9.5683C16.15 9.74928 15.9353 9.83976 15.6792 9.83976H4.32046C4.06435 9.83976 3.84963 9.74928 3.6763 9.5683C3.5031 9.38733 3.4165 9.16046 3.4165 8.88768V4.57497C3.4165 4.31941 3.5031 4.10525 3.6763 3.93247C3.84963 3.75955 4.06435 3.6731 4.32046 3.6731ZM4.49984 4.75643V8.75643H15.4998V4.75643H4.49984ZM4.32046 11.1602H15.6632C15.9305 11.1602 16.1507 11.2499 16.3236 11.4293C16.4966 11.6087 16.5832 11.8309 16.5832 12.0962V16.3589C16.5832 16.6423 16.4966 16.8744 16.3236 17.0554C16.1507 17.2364 15.9305 17.3268 15.6632 17.3268H4.3365C4.06914 17.3268 3.849 17.2364 3.67609 17.0554C3.50303 16.8744 3.4165 16.6423 3.4165 16.3589V12.0962C3.4165 11.8309 3.50032 11.6087 3.66796 11.4293C3.8356 11.2499 4.0531 11.1602 4.32046 11.1602ZM4.49984 12.2435V16.2435H15.4998V12.2435H4.49984Z"
                    fill="#1C1C1C"
                    fill-opacity="0.8"
                  />
                </svg>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    color: BLACK.B_80,
                  }}
                >
                  Brand Management
                </div>
              </div>
            )}
            {user_type === "ADMIN" && (
              <div
                className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
                onClick={() =>
                  onClickElementHandler("/userManagement/userList")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M1.13775 14.8238C0.933448 14.8238 0.762129 14.7547 0.623796 14.6165C0.485601 14.4782 0.416504 14.3069 0.416504 14.1026V13.8078C0.416504 13.2533 0.706018 12.7979 1.28505 12.4415C1.86421 12.0853 2.61907 11.9071 3.54963 11.9071C3.70338 11.9071 3.85824 11.9119 4.01421 11.9215C4.17018 11.9311 4.32727 11.9498 4.48546 11.9776C4.3231 12.2373 4.20262 12.5068 4.124 12.7861C4.04553 13.0655 4.0063 13.3521 4.0063 13.6459V14.8238H1.13775ZM6.17296 14.8238C5.95602 14.8238 5.77574 14.7516 5.63213 14.6071C5.48838 14.4628 5.4165 14.2839 5.4165 14.0705V13.678C5.4165 13.2878 5.52602 12.9312 5.74505 12.6082C5.96407 12.285 6.27977 12.0032 6.69213 11.763C7.10449 11.5226 7.59171 11.3423 8.1538 11.2221C8.71574 11.1019 9.33004 11.0417 9.99671 11.0417C10.6762 11.0417 11.2969 11.1019 11.8588 11.2221C12.4207 11.3423 12.9079 11.5226 13.3203 11.763C13.7328 12.0032 14.0464 12.285 14.2611 12.6082C14.4758 12.9312 14.5832 13.2878 14.5832 13.678V14.0705C14.5832 14.2839 14.5109 14.4628 14.3665 14.6071C14.2222 14.7516 14.0433 14.8238 13.8298 14.8238H6.17296ZM15.9934 14.8238V13.6469C15.9934 13.3332 15.9563 13.038 15.8821 12.7613C15.8078 12.4846 15.6964 12.2234 15.548 11.9776C15.7114 11.9498 15.8677 11.9311 16.0167 11.9215C16.1657 11.9119 16.3129 11.9071 16.4582 11.9071C17.3887 11.9071 18.1422 12.0832 18.7186 12.4353C19.295 12.7872 19.5832 13.2447 19.5832 13.8078V14.1026C19.5832 14.3069 19.5141 14.4782 19.3759 14.6165C19.2375 14.7547 19.0662 14.8238 18.8619 14.8238H15.9934ZM6.73067 13.5738H13.2819V13.4857C13.1965 13.1491 12.8418 12.866 12.2178 12.6363C11.5939 12.4066 10.8546 12.2917 9.99984 12.2917C9.14511 12.2917 8.40581 12.4066 7.78192 12.6363C7.15789 12.866 6.80748 13.1491 6.73067 13.4857V13.5738ZM3.54734 11.0978C3.15456 11.0978 2.819 10.9581 2.54067 10.6788C2.26234 10.3995 2.12317 10.0637 2.12317 9.67151C2.12317 9.27415 2.26289 8.93846 2.54234 8.66443C2.82164 8.3904 3.15741 8.25339 3.54963 8.25339C3.94699 8.25339 4.284 8.3904 4.56067 8.66443C4.83748 8.93846 4.97588 9.27498 4.97588 9.67401C4.97588 10.0612 4.83893 10.3953 4.56505 10.6763C4.2913 10.9573 3.95206 11.0978 3.54734 11.0978ZM16.4582 11.0978C16.0693 11.0978 15.7344 10.9573 15.4534 10.6763C15.1724 10.3953 15.0319 10.0612 15.0319 9.67401C15.0319 9.27498 15.1724 8.93846 15.4534 8.66443C15.7344 8.3904 16.0698 8.25339 16.4596 8.25339C16.8614 8.25339 17.1994 8.3904 17.4734 8.66443C17.7474 8.93846 17.8844 9.27415 17.8844 9.67151C17.8844 10.0637 17.7478 10.3995 17.4744 10.6788C17.2011 10.9581 16.8623 11.0978 16.4582 11.0978ZM10.0028 10.4167C9.40248 10.4167 8.89137 10.2064 8.46942 9.78568C8.04748 9.36512 7.8365 8.85436 7.8365 8.25339C7.8365 7.64033 8.04678 7.12651 8.46734 6.71193C8.88803 6.2972 9.39886 6.08984 9.99984 6.08984C10.6128 6.08984 11.1266 6.29693 11.5413 6.71109C11.9559 7.12512 12.1632 7.63825 12.1632 8.25047C12.1632 8.85061 11.9562 9.36172 11.5421 9.7838C11.128 10.2057 10.6148 10.4167 10.0028 10.4167ZM10.0038 9.16672C10.2587 9.16672 10.4739 9.07755 10.6496 8.89922C10.8255 8.72075 10.9134 8.50408 10.9134 8.24922C10.9134 7.9945 10.8258 7.77922 10.6507 7.60339C10.4755 7.42769 10.2586 7.33984 9.99984 7.33984C9.74775 7.33984 9.53248 7.42741 9.354 7.60255C9.17553 7.77755 9.0863 7.9945 9.0863 8.25339C9.0863 8.50547 9.17553 8.72075 9.354 8.89922C9.53248 9.07755 9.74907 9.16672 10.0038 9.16672Z"
                    fill="#1C1C1C"
                    fill-opacity="0.8"
                  />
                </svg>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    color: BLACK.B_80,
                  }}
                >
                  User Management
                </div>
              </div>
            )}

          <div
              className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
              onClick={() =>
                onClickElementHandler(`/giveAccess/ads/${brand_id}`)
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M1.13775 14.8238C0.933448 14.8238 0.762129 14.7547 0.623796 14.6165C0.485601 14.4782 0.416504 14.3069 0.416504 14.1026V13.8078C0.416504 13.2533 0.706018 12.7979 1.28505 12.4415C1.86421 12.0853 2.61907 11.9071 3.54963 11.9071C3.70338 11.9071 3.85824 11.9119 4.01421 11.9215C4.17018 11.9311 4.32727 11.9498 4.48546 11.9776C4.3231 12.2373 4.20262 12.5068 4.124 12.7861C4.04553 13.0655 4.0063 13.3521 4.0063 13.6459V14.8238H1.13775ZM6.17296 14.8238C5.95602 14.8238 5.77574 14.7516 5.63213 14.6071C5.48838 14.4628 5.4165 14.2839 5.4165 14.0705V13.678C5.4165 13.2878 5.52602 12.9312 5.74505 12.6082C5.96407 12.285 6.27977 12.0032 6.69213 11.763C7.10449 11.5226 7.59171 11.3423 8.1538 11.2221C8.71574 11.1019 9.33004 11.0417 9.99671 11.0417C10.6762 11.0417 11.2969 11.1019 11.8588 11.2221C12.4207 11.3423 12.9079 11.5226 13.3203 11.763C13.7328 12.0032 14.0464 12.285 14.2611 12.6082C14.4758 12.9312 14.5832 13.2878 14.5832 13.678V14.0705C14.5832 14.2839 14.5109 14.4628 14.3665 14.6071C14.2222 14.7516 14.0433 14.8238 13.8298 14.8238H6.17296ZM15.9934 14.8238V13.6469C15.9934 13.3332 15.9563 13.038 15.8821 12.7613C15.8078 12.4846 15.6964 12.2234 15.548 11.9776C15.7114 11.9498 15.8677 11.9311 16.0167 11.9215C16.1657 11.9119 16.3129 11.9071 16.4582 11.9071C17.3887 11.9071 18.1422 12.0832 18.7186 12.4353C19.295 12.7872 19.5832 13.2447 19.5832 13.8078V14.1026C19.5832 14.3069 19.5141 14.4782 19.3759 14.6165C19.2375 14.7547 19.0662 14.8238 18.8619 14.8238H15.9934ZM6.73067 13.5738H13.2819V13.4857C13.1965 13.1491 12.8418 12.866 12.2178 12.6363C11.5939 12.4066 10.8546 12.2917 9.99984 12.2917C9.14511 12.2917 8.40581 12.4066 7.78192 12.6363C7.15789 12.866 6.80748 13.1491 6.73067 13.4857V13.5738ZM3.54734 11.0978C3.15456 11.0978 2.819 10.9581 2.54067 10.6788C2.26234 10.3995 2.12317 10.0637 2.12317 9.67151C2.12317 9.27415 2.26289 8.93846 2.54234 8.66443C2.82164 8.3904 3.15741 8.25339 3.54963 8.25339C3.94699 8.25339 4.284 8.3904 4.56067 8.66443C4.83748 8.93846 4.97588 9.27498 4.97588 9.67401C4.97588 10.0612 4.83893 10.3953 4.56505 10.6763C4.2913 10.9573 3.95206 11.0978 3.54734 11.0978ZM16.4582 11.0978C16.0693 11.0978 15.7344 10.9573 15.4534 10.6763C15.1724 10.3953 15.0319 10.0612 15.0319 9.67401C15.0319 9.27498 15.1724 8.93846 15.4534 8.66443C15.7344 8.3904 16.0698 8.25339 16.4596 8.25339C16.8614 8.25339 17.1994 8.3904 17.4734 8.66443C17.7474 8.93846 17.8844 9.27415 17.8844 9.67151C17.8844 10.0637 17.7478 10.3995 17.4744 10.6788C17.2011 10.9581 16.8623 11.0978 16.4582 11.0978ZM10.0028 10.4167C9.40248 10.4167 8.89137 10.2064 8.46942 9.78568C8.04748 9.36512 7.8365 8.85436 7.8365 8.25339C7.8365 7.64033 8.04678 7.12651 8.46734 6.71193C8.88803 6.2972 9.39886 6.08984 9.99984 6.08984C10.6128 6.08984 11.1266 6.29693 11.5413 6.71109C11.9559 7.12512 12.1632 7.63825 12.1632 8.25047C12.1632 8.85061 11.9562 9.36172 11.5421 9.7838C11.128 10.2057 10.6148 10.4167 10.0028 10.4167ZM10.0038 9.16672C10.2587 9.16672 10.4739 9.07755 10.6496 8.89922C10.8255 8.72075 10.9134 8.50408 10.9134 8.24922C10.9134 7.9945 10.8258 7.77922 10.6507 7.60339C10.4755 7.42769 10.2586 7.33984 9.99984 7.33984C9.74775 7.33984 9.53248 7.42741 9.354 7.60255C9.17553 7.77755 9.0863 7.9945 9.0863 8.25339C9.0863 8.50547 9.17553 8.72075 9.354 8.89922C9.53248 9.07755 9.74907 9.16672 10.0038 9.16672Z"
                  fill="#1C1C1C"
                  fill-opacity="0.8"
                />
              </svg>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: BLACK.B_80,
                }}
              >
                Amazon Give Access
              </div>
            </div>

            <div
              className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
              onClick={() =>
                onClickElementHandler(`/flipkartgiveAccess/seller/${brand_id}`)
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M1.13775 14.8238C0.933448 14.8238 0.762129 14.7547 0.623796 14.6165C0.485601 14.4782 0.416504 14.3069 0.416504 14.1026V13.8078C0.416504 13.2533 0.706018 12.7979 1.28505 12.4415C1.86421 12.0853 2.61907 11.9071 3.54963 11.9071C3.70338 11.9071 3.85824 11.9119 4.01421 11.9215C4.17018 11.9311 4.32727 11.9498 4.48546 11.9776C4.3231 12.2373 4.20262 12.5068 4.124 12.7861C4.04553 13.0655 4.0063 13.3521 4.0063 13.6459V14.8238H1.13775ZM6.17296 14.8238C5.95602 14.8238 5.77574 14.7516 5.63213 14.6071C5.48838 14.4628 5.4165 14.2839 5.4165 14.0705V13.678C5.4165 13.2878 5.52602 12.9312 5.74505 12.6082C5.96407 12.285 6.27977 12.0032 6.69213 11.763C7.10449 11.5226 7.59171 11.3423 8.1538 11.2221C8.71574 11.1019 9.33004 11.0417 9.99671 11.0417C10.6762 11.0417 11.2969 11.1019 11.8588 11.2221C12.4207 11.3423 12.9079 11.5226 13.3203 11.763C13.7328 12.0032 14.0464 12.285 14.2611 12.6082C14.4758 12.9312 14.5832 13.2878 14.5832 13.678V14.0705C14.5832 14.2839 14.5109 14.4628 14.3665 14.6071C14.2222 14.7516 14.0433 14.8238 13.8298 14.8238H6.17296ZM15.9934 14.8238V13.6469C15.9934 13.3332 15.9563 13.038 15.8821 12.7613C15.8078 12.4846 15.6964 12.2234 15.548 11.9776C15.7114 11.9498 15.8677 11.9311 16.0167 11.9215C16.1657 11.9119 16.3129 11.9071 16.4582 11.9071C17.3887 11.9071 18.1422 12.0832 18.7186 12.4353C19.295 12.7872 19.5832 13.2447 19.5832 13.8078V14.1026C19.5832 14.3069 19.5141 14.4782 19.3759 14.6165C19.2375 14.7547 19.0662 14.8238 18.8619 14.8238H15.9934ZM6.73067 13.5738H13.2819V13.4857C13.1965 13.1491 12.8418 12.866 12.2178 12.6363C11.5939 12.4066 10.8546 12.2917 9.99984 12.2917C9.14511 12.2917 8.40581 12.4066 7.78192 12.6363C7.15789 12.866 6.80748 13.1491 6.73067 13.4857V13.5738ZM3.54734 11.0978C3.15456 11.0978 2.819 10.9581 2.54067 10.6788C2.26234 10.3995 2.12317 10.0637 2.12317 9.67151C2.12317 9.27415 2.26289 8.93846 2.54234 8.66443C2.82164 8.3904 3.15741 8.25339 3.54963 8.25339C3.94699 8.25339 4.284 8.3904 4.56067 8.66443C4.83748 8.93846 4.97588 9.27498 4.97588 9.67401C4.97588 10.0612 4.83893 10.3953 4.56505 10.6763C4.2913 10.9573 3.95206 11.0978 3.54734 11.0978ZM16.4582 11.0978C16.0693 11.0978 15.7344 10.9573 15.4534 10.6763C15.1724 10.3953 15.0319 10.0612 15.0319 9.67401C15.0319 9.27498 15.1724 8.93846 15.4534 8.66443C15.7344 8.3904 16.0698 8.25339 16.4596 8.25339C16.8614 8.25339 17.1994 8.3904 17.4734 8.66443C17.7474 8.93846 17.8844 9.27415 17.8844 9.67151C17.8844 10.0637 17.7478 10.3995 17.4744 10.6788C17.2011 10.9581 16.8623 11.0978 16.4582 11.0978ZM10.0028 10.4167C9.40248 10.4167 8.89137 10.2064 8.46942 9.78568C8.04748 9.36512 7.8365 8.85436 7.8365 8.25339C7.8365 7.64033 8.04678 7.12651 8.46734 6.71193C8.88803 6.2972 9.39886 6.08984 9.99984 6.08984C10.6128 6.08984 11.1266 6.29693 11.5413 6.71109C11.9559 7.12512 12.1632 7.63825 12.1632 8.25047C12.1632 8.85061 11.9562 9.36172 11.5421 9.7838C11.128 10.2057 10.6148 10.4167 10.0028 10.4167ZM10.0038 9.16672C10.2587 9.16672 10.4739 9.07755 10.6496 8.89922C10.8255 8.72075 10.9134 8.50408 10.9134 8.24922C10.9134 7.9945 10.8258 7.77922 10.6507 7.60339C10.4755 7.42769 10.2586 7.33984 9.99984 7.33984C9.74775 7.33984 9.53248 7.42741 9.354 7.60255C9.17553 7.77755 9.0863 7.9945 9.0863 8.25339C9.0863 8.50547 9.17553 8.72075 9.354 8.89922C9.53248 9.07755 9.74907 9.16672 10.0038 9.16672Z"
                  fill="#1C1C1C"
                  fill-opacity="0.8"
                />
              </svg>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: BLACK.B_80,
                }}
              >
                Flipkart Give Access
              </div>
            </div>
              {/* <div
              className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
              onClick={() =>
                onClickElementHandler("/Ads_dashboard/overview/comparison")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M1.13775 14.8238C0.933448 14.8238 0.762129 14.7547 0.623796 14.6165C0.485601 14.4782 0.416504 14.3069 0.416504 14.1026V13.8078C0.416504 13.2533 0.706018 12.7979 1.28505 12.4415C1.86421 12.0853 2.61907 11.9071 3.54963 11.9071C3.70338 11.9071 3.85824 11.9119 4.01421 11.9215C4.17018 11.9311 4.32727 11.9498 4.48546 11.9776C4.3231 12.2373 4.20262 12.5068 4.124 12.7861C4.04553 13.0655 4.0063 13.3521 4.0063 13.6459V14.8238H1.13775ZM6.17296 14.8238C5.95602 14.8238 5.77574 14.7516 5.63213 14.6071C5.48838 14.4628 5.4165 14.2839 5.4165 14.0705V13.678C5.4165 13.2878 5.52602 12.9312 5.74505 12.6082C5.96407 12.285 6.27977 12.0032 6.69213 11.763C7.10449 11.5226 7.59171 11.3423 8.1538 11.2221C8.71574 11.1019 9.33004 11.0417 9.99671 11.0417C10.6762 11.0417 11.2969 11.1019 11.8588 11.2221C12.4207 11.3423 12.9079 11.5226 13.3203 11.763C13.7328 12.0032 14.0464 12.285 14.2611 12.6082C14.4758 12.9312 14.5832 13.2878 14.5832 13.678V14.0705C14.5832 14.2839 14.5109 14.4628 14.3665 14.6071C14.2222 14.7516 14.0433 14.8238 13.8298 14.8238H6.17296ZM15.9934 14.8238V13.6469C15.9934 13.3332 15.9563 13.038 15.8821 12.7613C15.8078 12.4846 15.6964 12.2234 15.548 11.9776C15.7114 11.9498 15.8677 11.9311 16.0167 11.9215C16.1657 11.9119 16.3129 11.9071 16.4582 11.9071C17.3887 11.9071 18.1422 12.0832 18.7186 12.4353C19.295 12.7872 19.5832 13.2447 19.5832 13.8078V14.1026C19.5832 14.3069 19.5141 14.4782 19.3759 14.6165C19.2375 14.7547 19.0662 14.8238 18.8619 14.8238H15.9934ZM6.73067 13.5738H13.2819V13.4857C13.1965 13.1491 12.8418 12.866 12.2178 12.6363C11.5939 12.4066 10.8546 12.2917 9.99984 12.2917C9.14511 12.2917 8.40581 12.4066 7.78192 12.6363C7.15789 12.866 6.80748 13.1491 6.73067 13.4857V13.5738ZM3.54734 11.0978C3.15456 11.0978 2.819 10.9581 2.54067 10.6788C2.26234 10.3995 2.12317 10.0637 2.12317 9.67151C2.12317 9.27415 2.26289 8.93846 2.54234 8.66443C2.82164 8.3904 3.15741 8.25339 3.54963 8.25339C3.94699 8.25339 4.284 8.3904 4.56067 8.66443C4.83748 8.93846 4.97588 9.27498 4.97588 9.67401C4.97588 10.0612 4.83893 10.3953 4.56505 10.6763C4.2913 10.9573 3.95206 11.0978 3.54734 11.0978ZM16.4582 11.0978C16.0693 11.0978 15.7344 10.9573 15.4534 10.6763C15.1724 10.3953 15.0319 10.0612 15.0319 9.67401C15.0319 9.27498 15.1724 8.93846 15.4534 8.66443C15.7344 8.3904 16.0698 8.25339 16.4596 8.25339C16.8614 8.25339 17.1994 8.3904 17.4734 8.66443C17.7474 8.93846 17.8844 9.27415 17.8844 9.67151C17.8844 10.0637 17.7478 10.3995 17.4744 10.6788C17.2011 10.9581 16.8623 11.0978 16.4582 11.0978ZM10.0028 10.4167C9.40248 10.4167 8.89137 10.2064 8.46942 9.78568C8.04748 9.36512 7.8365 8.85436 7.8365 8.25339C7.8365 7.64033 8.04678 7.12651 8.46734 6.71193C8.88803 6.2972 9.39886 6.08984 9.99984 6.08984C10.6128 6.08984 11.1266 6.29693 11.5413 6.71109C11.9559 7.12512 12.1632 7.63825 12.1632 8.25047C12.1632 8.85061 11.9562 9.36172 11.5421 9.7838C11.128 10.2057 10.6148 10.4167 10.0028 10.4167ZM10.0038 9.16672C10.2587 9.16672 10.4739 9.07755 10.6496 8.89922C10.8255 8.72075 10.9134 8.50408 10.9134 8.24922C10.9134 7.9945 10.8258 7.77922 10.6507 7.60339C10.4755 7.42769 10.2586 7.33984 9.99984 7.33984C9.74775 7.33984 9.53248 7.42741 9.354 7.60255C9.17553 7.77755 9.0863 7.9945 9.0863 8.25339C9.0863 8.50547 9.17553 8.72075 9.354 8.89922C9.53248 9.07755 9.74907 9.16672 10.0038 9.16672Z"
                  fill="#1C1C1C"
                  fill-opacity="0.8"
                />
              </svg>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: BLACK.B_80,
                }}
              >
                Ads Dashboard
              </div>
            </div> */}
            <div
              className="flex py-[8px] px-[16px] items-center gap-[10px] self-stretch cursor-pointer"
              onClick={onLogoutClickHandler}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M8.75 16.875C8.75 17.0408 8.68415 17.1997 8.56694 17.3169C8.44973 17.4342 8.29076 17.5 8.125 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H8.125C8.29076 2.5 8.44973 2.56585 8.56694 2.68306C8.68415 2.80027 8.75 2.95924 8.75 3.125C8.75 3.29076 8.68415 3.44973 8.56694 3.56694C8.44973 3.68415 8.29076 3.75 8.125 3.75H3.75V16.25H8.125C8.29076 16.25 8.44973 16.3158 8.56694 16.4331C8.68415 16.5503 8.75 16.7092 8.75 16.875ZM17.3172 9.55781L14.1922 6.43281C14.0749 6.31554 13.9159 6.24965 13.75 6.24965C13.5841 6.24965 13.4251 6.31554 13.3078 6.43281C13.1905 6.55009 13.1247 6.70915 13.1247 6.875C13.1247 7.04085 13.1905 7.19991 13.3078 7.31719L15.3664 9.375H8.125C7.95924 9.375 7.80027 9.44085 7.68306 9.55806C7.56585 9.67527 7.5 9.83424 7.5 10C7.5 10.1658 7.56585 10.3247 7.68306 10.4419C7.80027 10.5592 7.95924 10.625 8.125 10.625H15.3664L13.3078 12.6828C13.1905 12.8001 13.1247 12.9591 13.1247 13.125C13.1247 13.2909 13.1905 13.4499 13.3078 13.5672C13.4251 13.6845 13.5841 13.7503 13.75 13.7503C13.9159 13.7503 14.0749 13.6845 14.1922 13.5672L17.3172 10.4422C17.3753 10.3841 17.4214 10.3152 17.4529 10.2393C17.4843 10.1635 17.5005 10.0821 17.5005 10C17.5005 9.91787 17.4843 9.83654 17.4529 9.76066C17.4214 9.68479 17.3753 9.61586 17.3172 9.55781Z"
                  fill="#D72C0D"
                />
              </svg>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: STATUS.S_Red,
                }}
              >
                Log out
              </div>
            </div>
          </div>
        </div>
      )}
      {/* old */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: 72,
            right: 76,
            backgroundColor: WHITE.W_100,
            zIndex: 999,
            padding: 24,
            borderRadius: "0px 0px 12px 12px",
            boxShadow: `0px 4px 10px 4px rgba(130,130,130,0.10)`,
          }}
        >
          {showAvatarEl && (
            <>
              <div
                style={{ borderBottom: `1px solid rgba(28,28,28,0.05)` }}
                className="flex flex-row pb-6"
              >
                <Avatar
                  sx={{ height: "40px", width: "40px", marginRight: "16px" }}
                  alt={full_name ? full_name : ""}
                  src={""}
                />
                <div className="flex flex-col justify-between  py-1">
                  <div
                    style={{
                      fontSize: 24,
                      fontWeight: 500,
                      color: BLACK.B_100,
                    }}
                  >
                    Hi, {full_name ? full_name : ""}
                  </div>
                  {/* <div onClick={() => navigate("/accountSetting")} style={{ fontSize: 14, fontWeight: 400, color: PRIMARY.P_BLue, borderBottom: `1px solid ${PRIMARY.P_BLue}` }} className="cursor-pointer max-w-fit" >Account Setting</div> */}
                </div>
              </div>
              <div style={{ borderBottom: `1px solid rgba(28,28,28,0.05)` }}>
                {subDashboards.length > 0 &&
                  subDashboards.map((sub_dashboard, i) => {

                    return (
                      <div
                        onClick={() => onClickElementHandler(sub_dashboard.url)}
                        className="flex flex-row py-2 pr-4 cursor-pointer"
                        // style={{borderBottom: i===subDashboards.length-1 ? `1px solid ${BLACK.B_100}` : "none"}}
                        key={sub_dashboard.sub_module_for_dashboard_type_id}
                      >
                        {/* <SubDashboardIcon url={sub_dashboard.url} /> */}
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                            lineHeight: "18px",
                            color: BLACK.B_80,
                          }}
                        >
                          {sub_dashboard.sub_module_for_dashboard_type}
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div>
                {user_type === "ADMIN" && (
                  <div
                    onClick={() =>
                      onClickElementHandler("/userManagement/userList")
                    }
                    className=" flex flex-row pt-6 pr-4 cursor-pointer"
                  >
                    <div className="mr-2 flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M1.13775 14.8238C0.933448 14.8238 0.762129 14.7547 0.623796 14.6165C0.485601 14.4782 0.416504 14.3069 0.416504 14.1026V13.8078C0.416504 13.2533 0.706018 12.7979 1.28505 12.4415C1.86421 12.0853 2.61907 11.9071 3.54963 11.9071C3.70338 11.9071 3.85824 11.9119 4.01421 11.9215C4.17018 11.9311 4.32727 11.9498 4.48546 11.9776C4.3231 12.2373 4.20262 12.5068 4.124 12.7861C4.04553 13.0655 4.0063 13.3521 4.0063 13.6459V14.8238H1.13775ZM6.17296 14.8238C5.95602 14.8238 5.77574 14.7516 5.63213 14.6071C5.48838 14.4628 5.4165 14.2839 5.4165 14.0705V13.678C5.4165 13.2878 5.52602 12.9312 5.74505 12.6082C5.96407 12.285 6.27977 12.0032 6.69213 11.763C7.10449 11.5226 7.59171 11.3423 8.1538 11.2221C8.71574 11.1019 9.33004 11.0417 9.99671 11.0417C10.6762 11.0417 11.2969 11.1019 11.8588 11.2221C12.4207 11.3423 12.9079 11.5226 13.3203 11.763C13.7328 12.0032 14.0464 12.285 14.2611 12.6082C14.4758 12.9312 14.5832 13.2878 14.5832 13.678V14.0705C14.5832 14.2839 14.5109 14.4628 14.3665 14.6071C14.2222 14.7516 14.0433 14.8238 13.8298 14.8238H6.17296ZM15.9934 14.8238V13.6469C15.9934 13.3332 15.9563 13.038 15.8821 12.7613C15.8078 12.4846 15.6964 12.2234 15.548 11.9776C15.7114 11.9498 15.8677 11.9311 16.0167 11.9215C16.1657 11.9119 16.3129 11.9071 16.4582 11.9071C17.3887 11.9071 18.1422 12.0832 18.7186 12.4353C19.295 12.7872 19.5832 13.2447 19.5832 13.8078V14.1026C19.5832 14.3069 19.5141 14.4782 19.3759 14.6165C19.2375 14.7547 19.0662 14.8238 18.8619 14.8238H15.9934ZM6.73067 13.5738H13.2819V13.4857C13.1965 13.1491 12.8418 12.866 12.2178 12.6363C11.5939 12.4066 10.8546 12.2917 9.99984 12.2917C9.14511 12.2917 8.40581 12.4066 7.78192 12.6363C7.15789 12.866 6.80748 13.1491 6.73067 13.4857V13.5738ZM3.54734 11.0978C3.15456 11.0978 2.819 10.9581 2.54067 10.6788C2.26234 10.3995 2.12317 10.0637 2.12317 9.67151C2.12317 9.27415 2.26289 8.93846 2.54234 8.66443C2.82164 8.3904 3.15741 8.25339 3.54963 8.25339C3.94699 8.25339 4.284 8.3904 4.56067 8.66443C4.83748 8.93846 4.97588 9.27498 4.97588 9.67401C4.97588 10.0612 4.83893 10.3953 4.56505 10.6763C4.2913 10.9573 3.95206 11.0978 3.54734 11.0978ZM16.4582 11.0978C16.0693 11.0978 15.7344 10.9573 15.4534 10.6763C15.1724 10.3953 15.0319 10.0612 15.0319 9.67401C15.0319 9.27498 15.1724 8.93846 15.4534 8.66443C15.7344 8.3904 16.0698 8.25339 16.4596 8.25339C16.8614 8.25339 17.1994 8.3904 17.4734 8.66443C17.7474 8.93846 17.8844 9.27415 17.8844 9.67151C17.8844 10.0637 17.7478 10.3995 17.4744 10.6788C17.2011 10.9581 16.8623 11.0978 16.4582 11.0978ZM10.0028 10.4167C9.40248 10.4167 8.89137 10.2064 8.46942 9.78568C8.04748 9.36512 7.8365 8.85436 7.8365 8.25339C7.8365 7.64033 8.04678 7.12651 8.46734 6.71193C8.88803 6.2972 9.39886 6.08984 9.99984 6.08984C10.6128 6.08984 11.1266 6.29693 11.5413 6.71109C11.9559 7.12512 12.1632 7.63825 12.1632 8.25047C12.1632 8.85061 11.9562 9.36172 11.5421 9.7838C11.128 10.2057 10.6148 10.4167 10.0028 10.4167ZM10.0038 9.16672C10.2587 9.16672 10.4739 9.07755 10.6496 8.89922C10.8255 8.72075 10.9134 8.50408 10.9134 8.24922C10.9134 7.9945 10.8258 7.77922 10.6507 7.60339C10.4755 7.42769 10.2586 7.33984 9.99984 7.33984C9.74775 7.33984 9.53248 7.42741 9.354 7.60255C9.17553 7.77755 9.0863 7.9945 9.0863 8.25339C9.0863 8.50547 9.17553 8.72075 9.354 8.89922C9.53248 9.07755 9.74907 9.16672 10.0038 9.16672Z"
                          fill="#1C1C1C"
                          fill-opacity="0.8"
                        />
                      </svg>
                    </div>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 500,
                        color: BLACK.B_80,
                      }}
                    >
                      User Management
                    </div>
                  </div>
                )}

                {user_type === "ADMIN" && (
                  <div
                    onClick={() =>
                      onClickElementHandler("/brandManagement/brandList")
                    }
                    className="flex flex-row pt-6 pr-4 cursor-pointer"
                  >
                    <div className="mr-2 flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M6.50088 5.96476C6.28116 5.96476 6.09414 6.04164 5.93984 6.19539C5.78539 6.34914 5.70817 6.5358 5.70817 6.75539C5.70817 6.97511 5.78505 7.16212 5.9388 7.31643C6.09255 7.47087 6.27921 7.5481 6.4988 7.5481C6.71852 7.5481 6.90553 7.47122 7.05984 7.31747C7.21428 7.16372 7.2915 6.97698 7.2915 6.75726C7.2915 6.53768 7.21463 6.35066 7.06088 6.19622C6.90713 6.04191 6.72046 5.96476 6.50088 5.96476ZM6.50088 13.4518C6.28116 13.4518 6.09414 13.5287 5.93984 13.6825C5.78539 13.8362 5.70817 14.023 5.70817 14.2427C5.70817 14.4623 5.78505 14.6493 5.9388 14.8037C6.09255 14.958 6.27921 15.0352 6.4988 15.0352C6.71852 15.0352 6.90553 14.9583 7.05984 14.8046C7.21428 14.6508 7.2915 14.4641 7.2915 14.2446C7.2915 14.0248 7.21463 13.8378 7.06088 13.6835C6.90713 13.5291 6.72046 13.4518 6.50088 13.4518ZM4.32046 3.6731H15.6792C15.9353 3.6731 16.15 3.75955 16.3234 3.93247C16.4966 4.10525 16.5832 4.31941 16.5832 4.57497V8.88768C16.5832 9.16046 16.4966 9.38733 16.3234 9.5683C16.15 9.74928 15.9353 9.83976 15.6792 9.83976H4.32046C4.06435 9.83976 3.84963 9.74928 3.6763 9.5683C3.5031 9.38733 3.4165 9.16046 3.4165 8.88768V4.57497C3.4165 4.31941 3.5031 4.10525 3.6763 3.93247C3.84963 3.75955 4.06435 3.6731 4.32046 3.6731ZM4.49984 4.75643V8.75643H15.4998V4.75643H4.49984ZM4.32046 11.1602H15.6632C15.9305 11.1602 16.1507 11.2499 16.3236 11.4293C16.4966 11.6087 16.5832 11.8309 16.5832 12.0962V16.3589C16.5832 16.6423 16.4966 16.8744 16.3236 17.0554C16.1507 17.2364 15.9305 17.3268 15.6632 17.3268H4.3365C4.06914 17.3268 3.849 17.2364 3.67609 17.0554C3.50303 16.8744 3.4165 16.6423 3.4165 16.3589V12.0962C3.4165 11.8309 3.50032 11.6087 3.66796 11.4293C3.8356 11.2499 4.0531 11.1602 4.32046 11.1602ZM4.49984 12.2435V16.2435H15.4998V12.2435H4.49984Z"
                          fill="#1C1C1C"
                          fill-opacity="0.8"
                        />
                      </svg>
                    </div>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 500,
                        color: BLACK.B_80,
                      }}
                    >
                      Brand Management
                    </div>
                  </div>
                )}
                {/* <div
                  onClick={() =>
                    onClickElementHandler("/unmappedData/productMaster")
                  }
                  className="flex flex-row pt-6 pr-4 cursor-pointer"
                >
                  <div className="mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12.375 20.25C9.91248 20.25 7.85931 19.9023 6.21548 19.2069C4.57183 18.5116 3.75 17.643 3.75 16.6009V6.55147C3.75 5.57194 4.5917 4.73515 6.2751 4.04109C7.95849 3.34703 9.99179 3 12.375 3C14.7582 3 16.7915 3.34703 18.4749 4.04109C20.1583 4.73515 21 5.57194 21 6.55147V16.6009C21 17.643 20.1782 18.5116 18.5345 19.2069C16.8907 19.9023 14.8375 20.25 12.375 20.25ZM12.375 8.53801C13.8541 8.53801 15.3434 8.3289 16.8428 7.91067C18.342 7.49244 19.2107 7.04132 19.4488 6.5573C19.2171 6.06044 18.3575 5.59697 16.8699 5.1669C15.3823 4.73701 13.884 4.52206 12.375 4.52206C10.8685 4.52206 9.37536 4.73117 7.89558 5.1494C6.4158 5.56763 5.54451 6.02391 5.2817 6.51824C5.53808 7.02559 6.40286 7.48906 7.87605 7.90864C9.3494 8.32822 10.8491 8.53801 12.375 8.53801ZM12.375 13.6153C13.0789 13.6153 13.7638 13.5815 14.4298 13.5139C15.0958 13.4462 15.7322 13.3474 16.3392 13.2173C16.946 13.0873 17.5141 12.9259 18.0437 12.7333C18.5732 12.5409 19.0513 12.3229 19.4779 12.0796V8.47941C19.0513 8.7226 18.5732 8.94051 18.0437 9.13314C17.5141 9.32559 16.946 9.48685 16.3392 9.6169C15.7322 9.74712 15.0958 9.84605 14.4298 9.9137C13.7638 9.98135 13.0789 10.0152 12.375 10.0152C11.6583 10.0152 10.96 9.97966 10.2801 9.90863C9.60046 9.83777 8.95882 9.73731 8.35524 9.60726C7.75166 9.47721 7.18935 9.31756 6.66829 9.12832C6.14724 8.9389 5.68183 8.7226 5.27206 8.47941V12.0796C5.68183 12.3229 6.14724 12.5393 6.66829 12.7285C7.18935 12.9177 7.75166 13.0774 8.35524 13.2074C8.95882 13.3377 9.60046 13.4382 10.2801 13.5091C10.96 13.5799 11.6583 13.6153 12.375 13.6153ZM12.375 18.7279C13.1984 18.7279 14.007 18.6737 14.8007 18.5651C15.5942 18.4563 16.3161 18.308 16.9665 18.1201C17.617 17.9321 18.1656 17.7138 18.6124 17.4654C19.0594 17.217 19.3479 16.9561 19.4779 16.6828V13.6016C19.0513 13.845 18.5732 14.0629 18.0437 14.2554C17.5141 14.448 16.946 14.6093 16.3392 14.7394C15.7322 14.8694 15.0958 14.9683 14.4298 15.0359C13.7638 15.1036 13.0789 15.1374 12.375 15.1374C11.6583 15.1374 10.96 15.102 10.2801 15.0311C9.60046 14.9603 8.95882 14.8597 8.35524 14.7295C7.75166 14.5994 7.18935 14.4398 6.66829 14.2506C6.14724 14.0613 5.68183 13.845 5.27206 13.6016V16.6985C5.40211 16.9783 5.688 17.2381 6.12974 17.4781C6.57131 17.7181 7.1173 17.9321 7.76773 18.1201C8.41832 18.308 9.14299 18.4563 9.94174 18.5651C10.7405 18.6737 11.5516 18.7279 12.375 18.7279Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: WHITE.W_100,
                    }}
                  >
                    Unmapped data
                  </div>
                </div> */}

                {/* <div
                  onClick={() =>
                    onClickElementHandler("/bulkUpload/latestFiles")
                  }
                  className="flex flex-row pt-6 pr-4 cursor-pointer"
                >
                  <div className="mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.0306 7.71938L14.7806 2.46938C14.7109 2.39975 14.6282 2.34454 14.5371 2.3069C14.4461 2.26926 14.3485 2.24992 14.25 2.25H5.25C4.85218 2.25 4.47064 2.40804 4.18934 2.68934C3.90804 2.97064 3.75 3.35218 3.75 3.75V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H18.75C19.1478 21.75 19.5294 21.592 19.8107 21.3107C20.092 21.0294 20.25 20.6478 20.25 20.25V8.25C20.2501 8.15148 20.2307 8.05391 20.1931 7.96286C20.1555 7.87182 20.1003 7.78908 20.0306 7.71938ZM15 4.81031L17.6897 7.5H15V4.81031ZM18.75 20.25H5.25V3.75H13.5V8.25C13.5 8.44891 13.579 8.63968 13.7197 8.78033C13.8603 8.92098 14.0511 9 14.25 9H18.75V20.25ZM15.75 12.75C15.75 12.9489 15.671 13.1397 15.5303 13.2803C15.3897 13.421 15.1989 13.5 15 13.5H9C8.80109 13.5 8.61032 13.421 8.46967 13.2803C8.32902 13.1397 8.25 12.9489 8.25 12.75C8.25 12.5511 8.32902 12.3603 8.46967 12.2197C8.61032 12.079 8.80109 12 9 12H15C15.1989 12 15.3897 12.079 15.5303 12.2197C15.671 12.3603 15.75 12.5511 15.75 12.75ZM15.75 15.75C15.75 15.9489 15.671 16.1397 15.5303 16.2803C15.3897 16.421 15.1989 16.5 15 16.5H9C8.80109 16.5 8.61032 16.421 8.46967 16.2803C8.32902 16.1397 8.25 15.9489 8.25 15.75C8.25 15.5511 8.32902 15.3603 8.46967 15.2197C8.61032 15.079 8.80109 15 9 15H15C15.1989 15 15.3897 15.079 15.5303 15.2197C15.671 15.3603 15.75 15.5511 15.75 15.75Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: WHITE.W_100,
                    }}
                  >
                    Bulk Upload
                  </div>
                </div> */}
                {user_type === "ADMIN" && (
                  <div
                    onClick={() =>
                      onClickElementHandler(
                        "/platformDashboardManagement/platformList"
                      )
                    }
                    className="flex flex-row pt-6 pr-4 cursor-pointer"
                  >
                    <div className="mr-2 flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M5.74984 10.7916H11.2498C11.4036 10.7916 11.5323 10.7402 11.6359 10.6373C11.7396 10.5345 11.7915 10.4068 11.7915 10.2543C11.7915 10.1018 11.7396 9.97274 11.6359 9.86704C11.5323 9.76121 11.4036 9.70829 11.2498 9.70829H5.74984C5.59609 9.70829 5.46741 9.75975 5.3638 9.86267C5.26005 9.96545 5.20817 10.0931 5.20817 10.2456C5.20817 10.3981 5.26005 10.5272 5.3638 10.6329C5.46741 10.7387 5.59609 10.7916 5.74984 10.7916ZM5.74984 8.29163H11.2498C11.4036 8.29163 11.5323 8.24017 11.6359 8.13725C11.7396 8.03447 11.7915 7.90683 11.7915 7.75433C11.7915 7.60183 11.7396 7.47274 11.6359 7.36704C11.5323 7.26121 11.4036 7.20829 11.2498 7.20829H5.74984C5.59609 7.20829 5.46741 7.25975 5.3638 7.36267C5.26005 7.46545 5.20817 7.59308 5.20817 7.74558C5.20817 7.89808 5.26005 8.02718 5.3638 8.13288C5.46741 8.23871 5.59609 8.29163 5.74984 8.29163ZM3.7563 15.5833C3.38116 15.5833 3.06407 15.4537 2.80505 15.1945C2.54602 14.9354 2.4165 14.6181 2.4165 14.2427V5.75058C2.4165 5.37517 2.54602 5.05899 2.80505 4.80204C3.06407 4.5451 3.38116 4.41663 3.7563 4.41663H16.2434C16.6185 4.41663 16.9356 4.54621 17.1946 4.80538C17.4537 5.06454 17.5832 5.38183 17.5832 5.75725V14.2493C17.5832 14.6248 17.4537 14.9409 17.1946 15.1979C16.9356 15.4548 16.6185 15.5833 16.2434 15.5833H3.7563ZM3.7563 14.5H16.2434C16.3075 14.5 16.3663 14.4732 16.4196 14.4198C16.4731 14.3664 16.4998 14.3077 16.4998 14.2435V5.75642C16.4998 5.69225 16.4731 5.6335 16.4196 5.58017C16.3663 5.52669 16.3075 5.49996 16.2434 5.49996H3.7563C3.69213 5.49996 3.63338 5.52669 3.58005 5.58017C3.52657 5.6335 3.49984 5.69225 3.49984 5.75642V14.2435C3.49984 14.3077 3.52657 14.3664 3.58005 14.4198C3.63338 14.4732 3.69213 14.5 3.7563 14.5Z"
                          fill="#1C1C1C"
                          fill-opacity="0.8"
                        />
                      </svg>
                    </div>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 500,
                        color: BLACK.B_80,
                      }}
                    >
                      Platform Management
                    </div>
                  </div>
                )}

                {/* <div onClick={() => onClickElementHandler("/onBoarding")} className="flex flex-row pt-6 pr-4 cursor-pointer">
                                            <div className="mr-2" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.9999 10.9998C13.2867 10.9998 14.3299 9.95662 14.3299 8.6698C14.3299 7.38298 13.2867 6.33984 11.9999 6.33984C10.7131 6.33984 9.66992 7.38298 9.66992 8.6698C9.66992 9.95662 10.7131 10.9998 11.9999 10.9998Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M16 16.6594C16 14.8594 14.21 13.3994 12 13.3994C9.79 13.3994 8 14.8594 8 16.6594" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <div style={{ fontSize: 18, fontWeight: 500, color: WHITE.W_100 }} >
                                                Onboarding
                                            </div>
                                        </div> */}

                {/* <div onClick={() => onClickElementHandler("/category")} className="flex flex-row pt-6 pr-4 cursor-pointer">
                                            <div className="mr-2" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M8.03077 9.23449L11.227 3.99624C11.3205 3.84241 11.4351 3.73274 11.5708 3.66724C11.7063 3.60191 11.8493 3.56924 12 3.56924C12.1507 3.56924 12.2938 3.60191 12.4293 3.66724C12.5649 3.73274 12.6795 3.84241 12.773 3.99624L15.9693 9.23449C16.0628 9.38516 16.1095 9.54333 16.1095 9.70899C16.1095 9.87483 16.0711 10.0263 15.9943 10.1635C15.9173 10.3007 15.8115 10.4102 15.677 10.4922C15.5423 10.5742 15.3853 10.6152 15.2058 10.6152H8.79427C8.6141 10.6152 8.45643 10.5738 8.32127 10.491C8.1861 10.4082 8.08093 10.299 8.00577 10.1635C7.92893 10.0283 7.89052 9.87816 7.89052 9.71299C7.89052 9.54783 7.93727 9.38833 8.03077 9.23449ZM17.5 21.6152C16.3525 21.6152 15.3798 21.2162 14.5818 20.4182C13.7838 19.6202 13.3848 18.6475 13.3848 17.5C13.3848 16.3525 13.7838 15.3797 14.5818 14.5817C15.3798 13.7837 16.3525 13.3847 17.5 13.3847C18.6475 13.3847 19.6203 13.7837 20.4183 14.5817C21.2163 15.3797 21.6153 16.3525 21.6153 17.5C21.6153 18.6475 21.2163 19.6202 20.4183 20.4182C19.6203 21.2162 18.6475 21.6152 17.5 21.6152ZM3.38477 20.2112V14.7862C3.38477 14.5301 3.47135 14.3157 3.64452 14.1432C3.81785 13.9709 4.0326 13.8847 4.28877 13.8847H9.71377C9.96993 13.8847 10.1843 13.9713 10.3568 14.1445C10.5291 14.3178 10.6153 14.5326 10.6153 14.7887V20.2137C10.6153 20.4699 10.5287 20.6842 10.3555 20.8567C10.1822 21.0291 9.96743 21.1152 9.71127 21.1152H4.28627C4.0301 21.1152 3.81577 21.0287 3.64327 20.8555C3.47093 20.6822 3.38477 20.4674 3.38477 20.2112ZM17.4998 20.1155C18.2319 20.1155 18.8509 19.8627 19.3568 19.357C19.8626 18.8513 20.1155 18.2324 20.1155 17.5002C20.1155 16.7681 19.8627 16.1491 19.357 15.6432C18.8513 15.1374 18.2324 14.8845 17.5003 14.8845C16.7681 14.8845 16.1491 15.1373 15.6433 15.643C15.1374 16.1487 14.8845 16.7676 14.8845 17.4997C14.8845 18.2319 15.1373 18.8509 15.643 19.3567C16.1487 19.8626 16.7676 20.1155 17.4998 20.1155ZM4.88452 19.6155H9.11552V15.3845H4.88452V19.6155ZM9.83852 9.11549H14.1615L12 5.63849L9.83852 9.11549Z" fill="white" />
                                                </svg>
                                            </div>
                                            <div style={{ fontSize: 18, fontWeight: 500, color: WHITE.W_100 }} >
                                                Category
                                            </div>
                                        </div>
                                        <div onClick={() => onClickElementHandler("/keyword")} className="flex flex-row pt-6 pr-4 cursor-pointer">
                                            <div className="mr-2" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M8.05825 16.7693C8.30908 16.7693 8.51917 16.6844 8.6885 16.5147C8.85767 16.3451 8.94225 16.1348 8.94225 15.884C8.94225 15.6332 8.85742 15.4231 8.68775 15.2538C8.51808 15.0846 8.30783 15 8.057 15C7.80617 15 7.59617 15.0848 7.427 15.2545C7.25767 15.4242 7.173 15.6344 7.173 15.8853C7.173 16.1361 7.25783 16.3461 7.4275 16.5152C7.59733 16.6846 7.80758 16.7693 8.05825 16.7693ZM8.05825 12.8845C8.30908 12.8845 8.51917 12.7997 8.6885 12.63C8.85767 12.4603 8.94225 12.2501 8.94225 11.9993C8.94225 11.7484 8.85742 11.5384 8.68775 11.3692C8.51808 11.2001 8.30783 11.1155 8.057 11.1155C7.80617 11.1155 7.59617 11.2003 7.427 11.37C7.25767 11.5397 7.173 11.7499 7.173 12.0008C7.173 12.2516 7.25783 12.4616 7.4275 12.6308C7.59733 12.7999 7.80758 12.8845 8.05825 12.8845ZM8.05825 9C8.30908 9 8.51917 8.91517 8.6885 8.7455C8.85767 8.57583 8.94225 8.36558 8.94225 8.11475C8.94225 7.86392 8.85742 7.65392 8.68775 7.48475C8.51808 7.31542 8.30783 7.23075 8.057 7.23075C7.80617 7.23075 7.59617 7.31558 7.427 7.48525C7.25767 7.65492 7.173 7.86517 7.173 8.116C7.173 8.36683 7.25783 8.57692 7.4275 8.74625C7.59733 8.91542 7.80758 9 8.05825 9ZM11.8463 16.6345H16.0385C16.251 16.6345 16.4291 16.5626 16.5727 16.4188C16.7166 16.2751 16.7885 16.0969 16.7885 15.8843C16.7885 15.6718 16.7166 15.4937 16.5727 15.35C16.4291 15.2065 16.251 15.1348 16.0385 15.1348H11.8463C11.6338 15.1348 11.4556 15.2066 11.3118 15.3503C11.1681 15.4941 11.0963 15.6723 11.0963 15.885C11.0963 16.0975 11.1681 16.2756 11.3118 16.4193C11.4556 16.5628 11.6338 16.6345 11.8463 16.6345ZM11.8463 12.75H16.0385C16.251 12.75 16.4291 12.6781 16.5727 12.5343C16.7166 12.3904 16.7885 12.2122 16.7885 11.9997C16.7885 11.7871 16.7166 11.609 16.5727 11.4655C16.4291 11.3218 16.251 11.25 16.0385 11.25H11.8463C11.6338 11.25 11.4556 11.3219 11.3118 11.4658C11.1681 11.6096 11.0963 11.7878 11.0963 12.0003C11.0963 12.2129 11.1681 12.391 11.3118 12.5345C11.4556 12.6782 11.6338 12.75 11.8463 12.75ZM11.8463 8.86525H16.0385C16.251 8.86525 16.4291 8.79342 16.5727 8.64975C16.7166 8.50592 16.7885 8.32767 16.7885 8.115C16.7885 7.9025 16.7166 7.72442 16.5727 7.58075C16.4291 7.43725 16.251 7.3655 16.0385 7.3655H11.8463C11.6338 7.3655 11.4556 7.43742 11.3118 7.58125C11.1681 7.72492 11.0963 7.90308 11.0963 8.11575C11.0963 8.32825 11.1681 8.50633 11.3118 8.65C11.4556 8.7935 11.6338 8.86525 11.8463 8.86525ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7693 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7693 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19Z" fill="white" />
                                                </svg>
                                            </div>
                                            <div style={{ fontSize: 18, fontWeight: 500, color: WHITE.W_100 }} >
                                                Keyword
                                            </div>
                                        </div>
                                        <div onClick={() => onClickElementHandler("/groupKeyword")} className="flex flex-row pt-6 pr-4 cursor-pointer">
                                            <div className="mr-2" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M20.9064 5.34374C19.8874 4.32735 18.5075 3.75579 17.0683 3.75403C15.6291 3.75227 14.2478 4.32047 13.2264 5.33436L12.0001 6.47342L10.7729 5.33061C9.75176 4.3123 8.3679 3.74136 6.92577 3.74338C5.48365 3.7454 4.10139 4.32023 3.08308 5.34139C2.06478 6.36256 1.49383 7.74642 1.49585 9.18855C1.49788 10.6307 2.0727 12.0129 3.09386 13.0312L11.4704 21.5306C11.5402 21.6015 11.6234 21.6578 11.7151 21.6962C11.8069 21.7346 11.9053 21.7544 12.0048 21.7544C12.1043 21.7544 12.2027 21.7346 12.2945 21.6962C12.3862 21.6578 12.4694 21.6015 12.5392 21.5306L20.9064 13.0312C21.9254 12.0116 22.4978 10.629 22.4978 9.18749C22.4978 7.74593 21.9254 6.36337 20.9064 5.34374ZM19.8423 11.9775L12.0001 19.9312L4.15324 11.97C3.41478 11.2315 2.99991 10.23 2.99991 9.18561C2.99991 8.14127 3.41478 7.1397 4.15324 6.40124C4.8917 5.66277 5.89327 5.24791 6.93761 5.24791C7.98196 5.24791 8.98353 5.66277 9.72199 6.40124L9.74074 6.41999L11.4892 8.04655C11.628 8.17571 11.8105 8.24751 12.0001 8.24751C12.1897 8.24751 12.3723 8.17571 12.5111 8.04655L14.2595 6.41999L14.2782 6.40124C15.0172 5.66327 16.019 5.24908 17.0634 5.24979C18.1077 5.25049 19.109 5.66603 19.847 6.40499C20.585 7.14395 20.9991 8.14579 20.9984 9.19014C20.9977 10.2345 20.5822 11.2358 19.8432 11.9737L19.8423 11.9775Z" fill="white" />
                                                </svg>
                                            </div>
                                            <div style={{ fontSize: 18, fontWeight: 500, color: WHITE.W_100 }} >
                                                Favourite Groups
                                            </div>
                                        </div> */}
                {/* <div className="flex flex-row pt-6 pr-4 cursor-pointer">
                                            <div className="mr-2" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21 4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V6C22.5 5.60218 22.342 5.22064 22.0607 4.93934C21.7794 4.65804 21.3978 4.5 21 4.5ZM21 6V8.25H3V6H21ZM21 18H3V9.75H21V18ZM19.5 15.75C19.5 15.9489 19.421 16.1397 19.2803 16.2803C19.1397 16.421 18.9489 16.5 18.75 16.5H15.75C15.5511 16.5 15.3603 16.421 15.2197 16.2803C15.079 16.1397 15 15.9489 15 15.75C15 15.5511 15.079 15.3603 15.2197 15.2197C15.3603 15.079 15.5511 15 15.75 15H18.75C18.9489 15 19.1397 15.079 19.2803 15.2197C19.421 15.3603 19.5 15.5511 19.5 15.75ZM13.5 15.75C13.5 15.9489 13.421 16.1397 13.2803 16.2803C13.1397 16.421 12.9489 16.5 12.75 16.5H11.25C11.0511 16.5 10.8603 16.421 10.7197 16.2803C10.579 16.1397 10.5 15.9489 10.5 15.75C10.5 15.5511 10.579 15.3603 10.7197 15.2197C10.8603 15.079 11.0511 15 11.25 15H12.75C12.9489 15 13.1397 15.079 13.2803 15.2197C13.421 15.3603 13.5 15.5511 13.5 15.75Z" fill="white" />
                                                </svg>
                                            </div>
                                            <div style={{ fontSize: 18, fontWeight: 500, color: WHITE.W_100 }} >
                                                Payments & Billing
                                            </div>
                                        </div> */}
                <div
                  onClick={onLogoutClickHandler}
                  style={{ width: "fit-content" }}
                  className="flex flex-row pt-6 pr-4 cursor-pointer"
                >
                  <div className="mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M10.5 20.25C10.5 20.4489 10.421 20.6397 10.2803 20.7803C10.1397 20.921 9.94891 21 9.75 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H9.75C9.94891 3 10.1397 3.07902 10.2803 3.21967C10.421 3.36032 10.5 3.55109 10.5 3.75C10.5 3.94891 10.421 4.13968 10.2803 4.28033C10.1397 4.42098 9.94891 4.5 9.75 4.5H4.5V19.5H9.75C9.94891 19.5 10.1397 19.579 10.2803 19.7197C10.421 19.8603 10.5 20.0511 10.5 20.25ZM20.7806 11.4694L17.0306 7.71937C16.8899 7.57864 16.699 7.49958 16.5 7.49958C16.301 7.49958 16.1101 7.57864 15.9694 7.71937C15.8286 7.86011 15.7496 8.05098 15.7496 8.25C15.7496 8.44902 15.8286 8.63989 15.9694 8.78063L18.4397 11.25H9.75C9.55109 11.25 9.36032 11.329 9.21967 11.4697C9.07902 11.6103 9 11.8011 9 12C9 12.1989 9.07902 12.3897 9.21967 12.5303C9.36032 12.671 9.55109 12.75 9.75 12.75H18.4397L15.9694 15.2194C15.8286 15.3601 15.7496 15.551 15.7496 15.75C15.7496 15.949 15.8286 16.1399 15.9694 16.2806C16.1101 16.4214 16.301 16.5004 16.5 16.5004C16.699 16.5004 16.8899 16.4214 17.0306 16.2806L20.7806 12.5306C20.8504 12.461 20.9057 12.3783 20.9434 12.2872C20.9812 12.1962 21.0006 12.0986 21.0006 12C21.0006 11.9014 20.9812 11.8038 20.9434 11.7128C20.9057 11.6217 20.8504 11.539 20.7806 11.4694Z"
                        fill="#D72C0D"
                        fill-opacity="0.8"
                      />
                    </svg>
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: STATUS.S_Red,
                    }}
                  >
                    Logout
                  </div>
                </div>
              </div>
            </>
          )}
          {showMenuEl && (
            <>
              {stage === "ONBOARDED" && (
                <>
                  {menuItems?.map((el) => {
                    return (
                      <div
                        key={el.id}
                        className="flex flex-row mb-6 pr-4 cursor-pointer"
                      >
                        <div className="mr-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.9999 10.9998C13.2867 10.9998 14.3299 9.95662 14.3299 8.6698C14.3299 7.38298 13.2867 6.33984 11.9999 6.33984C10.7131 6.33984 9.66992 7.38298 9.66992 8.6698C9.66992 9.95662 10.7131 10.9998 11.9999 10.9998Z"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M16 16.6594C16 14.8594 14.21 13.3994 12 13.3994C9.79 13.3994 8 14.8594 8 16.6594"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 500,
                            color: WHITE.W_100,
                          }}
                        >
                          {el.name}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
              {stage != "ONBOARDED" && (
                <div
                  onClick={() => navigate("/onBoarding")}
                  className="flex flex-row mb-6 pr-4 cursor-pointer"
                >
                  <div className="mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.9999 10.9998C13.2867 10.9998 14.3299 9.95662 14.3299 8.6698C14.3299 7.38298 13.2867 6.33984 11.9999 6.33984C10.7131 6.33984 9.66992 7.38298 9.66992 8.6698C9.66992 9.95662 10.7131 10.9998 11.9999 10.9998Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 16.6594C16 14.8594 14.21 13.3994 12 13.3994C9.79 13.3994 8 14.8594 8 16.6594"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: WHITE.W_100,
                    }}
                  >
                    Onboarding
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
      {false && <SupportModal setOpenSupport={setOpenSupport} />}
    </div>
  );
};

export default Header;
